import * as React from 'react';
import classnames from 'classnames';
import styled, { css } from 'styled-components';
import { BREAKPOINT, COLOR, MARGIN, PADDING } from '@latitude/core/utils/constants';
import { Box } from '@latitude/box';
import { Responsive } from '@latitude/spacing';
const Confetti1 = require(`./svg/confetti1.svg`);
const Confetti2 = require(`./svg/confetti2.svg`);
const OFFSET = '100px';
export const InnerContainer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "HowToApply__InnerContainer",
  componentId: "sc-1atcz78-0"
})(["background-color:", ";"], COLOR.BLUE_BABY);
export const ContentBox = /*#__PURE__*/styled(Box).withConfig({
  displayName: "HowToApply__ContentBox",
  componentId: "sc-1atcz78-1"
})(["", " position:relative;border:solid 20px ", ";background-color:", ";padding:", " 20px;width:100%;max-width:580px;ul{margin:0 0 0 ", ";li{position:relative;list-style:none;margin:0 0 0 ", ";::before{font-size:36px;position:absolute;top:0;left:-", ";color:", ";content:'\u2022';}}}"], props => {
  if (props.alignContent) {
    return css(["top:-60px;"]);
  }
  return css([":first-child{top:-", ";margin-bottom:calc(-", " + ", ");}:last-child{bottom:-", ";margin-top:-", ";}@media (min-width:", "){padding:", ";max-width:480px;:first-child{top:calc(-", " / 2);margin-bottom:calc(-", " / 2 + ", ");}:last-child{bottom:calc(-", " / 2);margin-top:auto;}}"], OFFSET, OFFSET, MARGIN.M24, OFFSET, OFFSET, BREAKPOINT.MD, PADDING.P32, OFFSET, OFFSET, MARGIN.M24, OFFSET);
}, COLOR.BLUE_SKY, COLOR.WHITE, PADDING.P32, MARGIN.M16, MARGIN.M8, MARGIN.M24, COLOR.BLUE_LIGHT);
export const StyledConfetti1 = /*#__PURE__*/styled(Confetti1).withConfig({
  displayName: "HowToApply__StyledConfetti1",
  componentId: "sc-1atcz78-2"
})(["display:none;@media (min-width:", "){display:block;position:absolute;bottom:0;left:", ";bottom:", ";right:", ";}"], BREAKPOINT.LG, props => !props.alignContent && '-100px', props => props.alignContent && '-80px', props => props.alignContent && '0');
export const StyledConfetti2 = /*#__PURE__*/styled(Confetti2).withConfig({
  displayName: "HowToApply__StyledConfetti2",
  componentId: "sc-1atcz78-3"
})(["display:none;@media (min-width:", "){display:block;position:absolute;top:", ";bottom:", ";right:-95px;}"], BREAKPOINT.LG, props => !props.alignContent && '-30px', props => props.alignContent && '-200px');
export const OuterContainer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "HowToApply__OuterContainer",
  componentId: "sc-1atcz78-4"
})(["background-color:", ";padding:calc(", " + ", ") 0;@media (min-width:", "){padding:calc(", " + ", " / 2) 0;}", ""], COLOR.GREY6, PADDING.P24, OFFSET, BREAKPOINT.MD, PADDING.P24, OFFSET, _ref => {
  let {
    equalHeight
  } = _ref;
  return equalHeight && css(["padding:", " 0;> h4{margin-bottom:96px;@media (min-width:", "){margin-bottom:112px;}}", "{margin-bottom:72px;}"], PADDING.P48, BREAKPOINT.LG, InnerContainer);
});
export const ContentBoxContainer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "HowToApply__ContentBoxContainer",
  componentId: "sc-1atcz78-5"
})(["margin:", " ", ";padding:", " ", ";max-width:1200px;", ""], MARGIN.M0, MARGIN.MAUTO, PADDING.P0, PADDING.P16, _ref2 => {
  let {
    equalHeight
  } = _ref2;
  return equalHeight && css(["> div{align-items:stretch;}", "{margin-left:auto;margin-right:auto;&:first-child{top:-60px;bottom:auto;margin-bottom:0;}&:last-child{top:auto;bottom:-60px;}}@media (min-width:", "){", "{&:first-child{top:auto;bottom:auto;margin-top:-72px;margin-bottom:-72px;margin-right:24px;},&:last-child{top:auto;bottom:auto;margin-top:-72px;margin-bottom:-72px;}}", "{bottom:70px;}", "{top:70px;}}"], ContentBox, BREAKPOINT.MD, ContentBox, StyledConfetti1, StyledConfetti2);
});
const HowToApply = _ref3 => {
  let {
    box1,
    box2,
    box3,
    alignContent = false,
    id,
    equalHeight,
    heading,
    className
  } = _ref3;
  return /*#__PURE__*/React.createElement(OuterContainer, {
    id: id,
    equalHeight: equalHeight,
    className: classnames("lfs-how-to-apply", className)
  }, heading, /*#__PURE__*/React.createElement(InnerContainer, {
    className: "lfs-inner-container"
  }, /*#__PURE__*/React.createElement(ContentBoxContainer, {
    equalHeight: equalHeight,
    className: "lfs-content-box-container"
  }, /*#__PURE__*/React.createElement(Responsive, {
    spacing: MARGIN.M24,
    className: "lfs-responsive"
  }, /*#__PURE__*/React.createElement(ContentBox, {
    alignContent: alignContent,
    className: "lfs-content-box"
  }, box1, /*#__PURE__*/React.createElement(StyledConfetti1, {
    alignContent: alignContent
  })), /*#__PURE__*/React.createElement(ContentBox, {
    alignContent: alignContent,
    className: "lfs-content-box"
  }, box2, /*#__PURE__*/React.createElement(StyledConfetti2, {
    alignContent: alignContent
  })), box3 && /*#__PURE__*/React.createElement(ContentBox, {
    alignContent: alignContent,
    className: "lfs-content-box"
  }, box3)))));
};
export default HowToApply;